import { render, staticRenderFns } from "./MainOnboardingComponent.vue?vue&type=template&id=30fb2b64&scoped=true"
import script from "./MainOnboardingComponent.vue?vue&type=script&lang=js"
export * from "./MainOnboardingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb2b64",
  null
  
)

export default component.exports